import React, { useEffect } from "react";

import facebookIcon from "../assets/icons/facebook.svg";

import "./styles.css";

function Login() {
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event?.data?.event === "logout") {
        handleLogout();
      }
    });
  }, []);

  const handleAuth = async (auth) => {
    window.parent.postMessage(
      {
        event: "getLoginStatus",
        auth,
      },
      "*"
    );
  };

  const handleLogout = async () => {
    window.FB.logout();
  };

  const handleLogin = async () => {
    await new Promise((res, rej) =>
      res(
        window.FB.login(
          (auth) => {
            handleAuth(auth);
            return auth;
          },
          {
            // public_profile,email,user_messenger_contact Não podem ser adicionados no login pela interface da meta
            // Mesmo não tendo os 3 lá, penas o scopo user_messenger_contact da erro se pedir, então mantenho pedindo os 2.
            scope:
              "pages_show_list,pages_messaging,pages_manage_metadata,public_profile,email,instagram_basic,instagram_manage_messages,pages_read_engagement,whatsapp_business_messaging,whatsapp_business_management,business_management",
            auth_type: "rerequest",
          }
        )
      )
    );
  };

  return (
    <div className="container">
      <button onClick={handleLogin} type="button">
        <img src={facebookIcon} alt="facebook-icon" />
        Entrar com facebook
      </button>
    </div>
  );
}

export default Login;
